import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {FilterProps} from "../components/table/tableTypes";

export const getCampaignsAvg = async (days: number, selectedDomain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `statistics/campaigns/dashboard-avg/${days}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}